import React from 'react';
import './gameUi.css';
import {joinClassNames} from './joinClassNames';
import {EngravedIcon} from './EngravedIcon';

/**
 * Углубление со значением ресурса: иконка, число и прирост
 * @param {string} icon - путь к иконке
 * @param {boolean} [maskIcon] - иконка одноцветная: перекрасить в цвет текста
 *   (для черных силуэтов вроде action.png); цветные (монеты) — как есть
 * @param {number|string} value
 * @param {number} [income] - прирост; 0 показывается как «+0»
 * @param {string} [title] - подсказка, что это за ресурс
 * @param {boolean} [bare] - без своего углубления: значение лежит в общей
 *   полосе ресурсов (.gui-stat-strip)
 */
export function StatWell({icon, maskIcon = false, value, income, title, bare = false, className, ...rest}) {
  return (
    <span className={joinClassNames('gui-stat-well', bare && 'gui-stat-well_bare', className)} title={title} {...rest}>
      {maskIcon
        ? <EngravedIcon src={icon} size={17} color={'var(--gui-well-ink)'}/>
        : <img className={'gui-stat-well_icon'} src={icon} alt={''}/>}
      <span className={'gui-stat-well_value'}>{value}</span>
      {income !== undefined && income !== null && (
        <span className={'gui-stat-well_income'}>{income >= 0 ? `+${income}` : income}</span>
      )}
    </span>
  );
}

export default StatWell;
